import { ChartPieIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";
import { buildCrudPermissions, permissionId } from "../../shared/featureFactories";

export const FinanceReportsFeature: FeatureMetadata = {
  id: "finance-reports",
  moduleName: "feesFinance",
  navigation: {
    label: "Finance Reports",
    path: "/finance-reports",
    icon: ChartPieIcon,
    order: 10,
  },
  route: {
    path: "/finance-reports",
    element: lazy(() => import("./pages/FinanceReportsDashboardPage")),
  },
  permissions: buildCrudPermissions("FeeFinance", "FinanceReports", {
    create: permissionId("FeeFinance", "FinanceReports", "analytics"),
    edit: permissionId("FeeFinance", "FinanceReports", "analytics"),
    delete: permissionId("FeeFinance", "FinanceReports", "analytics"),
  }),
  readiness: "live",
};
